import { render, staticRenderFns } from "./StarLevel.vue?vue&type=template&id=3b0257f6"
import script from "./StarLevel.vue?vue&type=script&lang=js"
export * from "./StarLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports